function hasDiscount({ offer_amount = 0, order_amount = 0 }) {
  return order_amount < offer_amount;
}

export default hasDiscount;
